const transition = {
  x: { type: 'spring', stiffness: 300, damping: 50 },
  opacity: { duration: 0.2 },
};

export const ImageSliderVariants = {
  enter: (direction: number) => {
    return {
      x: direction > 0 ? 500 : -500,
      opacity: 0,
      transition: { ...transition },
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
    transition: { ...transition },
  },
  exit: (direction: number) => {
    return {
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
      transition: { ...transition },
    };
  },
};
